import type { BasicUnitInfoInterface } from './baseTypes';
import type { FlowInterface } from './flowTypes';

export enum PortMode {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export interface EditMultipleUnitLocationsInterface {
  unitKey: string;
  location: string;
  panels: PanelType[];
}

export interface UnitInfoPrintWindowInterface extends BasicUnitInfoInterface {
  width: number;
  height: number;
}

export type TextAlignment = 'center' | 'left' | 'right';

export type TextWeight = 'regular' | 'bold';

export interface UnitInfoFreeTextBoxInterface extends BasicUnitInfoInterface {
  message: string;
  width: number;
  height: number;
  displayBorder: boolean;
  color: string;
  fontSize: number;
  textColor: string;
  textAlignment: TextAlignment;
  textWeight: TextWeight;
}

export interface GoJSInterface {
  category: string;
  variantId?: number;
  loc: string;
  outputFlowMass?: number;
  inputPorts: number;
  outputPorts: number;
  mirrored: boolean;
  hideNonMajorWarnings: boolean;
}

export type Group = {
  key: string;
  title: string;
  body: string;
  color: string;
  unitKeys: string[];
  textBoxKey: string;
};

export type NodeGroupInterface = Record<string, Group>;

export enum PanelType {
  INFO_PANEL = 'INFO_PANEL',
  WARNINGS_PANEL = 'WARNINGS_PANEL',
  FLOW_PROPERTIES_GRAPH_PANEL = 'FLOW_PROPERTIES_GRAPH_PANEL',
  FLOW_PROPERTIES_SIZE_TABLE_PANEL = 'FLOW_PROPERTIES_SIZE_TABLE_PANEL',
  FLOW_PROPERTIES_PXX_TABLE_PANEL = 'FLOW_PROPERTIES_PXX_TABLE_PANEL',
  PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL = 'PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL',
  PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL = 'PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL',
}

export interface PanelInterface {
  type: PanelType;
  loc: string;
  unitKey: string;
  width?: number;
  height?: number;
}

export interface PanelMapInterface {
  [key: string]: {
    [PanelType.INFO_PANEL]: PanelInterface;
    [PanelType.WARNINGS_PANEL]: PanelInterface;
    [PanelType.FLOW_PROPERTIES_GRAPH_PANEL]?: PanelInterface;
    [PanelType.FLOW_PROPERTIES_SIZE_TABLE_PANEL]?: PanelInterface;
    [PanelType.FLOW_PROPERTIES_PXX_TABLE_PANEL]: PanelInterface;
    [PanelType.PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL]?: PanelInterface;
    [PanelType.PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL]?: PanelInterface;
  };
}

export interface SimulationRequestUnitInterface {
  key: string;
  type: string;
  unitInfo?: unknown;
  inputFlow?: FlowInterface;
}

interface SimulationRequestPortInterface {
  key: string;
  unitKey: string;
  portMode: PortMode;
  portIndex: number;
}

export interface SimulationRequestPortsInterface {
  [key: string]: SimulationRequestPortInterface[];
}
